module.exports = __webpack_public_path__ + "img/fluid-wagon-4.ad541511.png";